import { type OrderMethod, fetcher } from "@repo/api";
import { useSettings, useStores } from "@repo/ui";
import useSWR from "swr";

interface StorePreference {
  orderCreationMethod: string[];
}

function useStorePreference(RCMP: string | undefined) {
  const { market } = useSettings();
  const key = RCMP ? `${market}/${RCMP}` : null;

  return useSWR<StorePreference>(key, (url: string) =>
    fetcher.saljaStorePreference.get<StorePreference>(url)
  );
}

const findStoreIdByRCMP = (
  storeLocations: Record<string, string> | undefined,
  name: string
): string | undefined => {
  if (!storeLocations || typeof storeLocations !== "object") {
    return undefined;
  }

  for (const [id, location] of Object.entries(storeLocations)) {
    if (location === name) {
      return id;
    }
  }

  return undefined;
};

const addAdditionalOrderMethods = (orderMethods: string[]) => {
  const additionalOrderMethods: OrderMethod[] = ["STORE", "INTERNET"];

  const extendedOrderMethods = additionalOrderMethods.reverse().reduce(
    (acc, currentValue) => {
      if (!acc.includes(currentValue)) {
        acc.unshift(currentValue);
      }
      return acc;
    },
    [...orderMethods]
  );

  return extendedOrderMethods;
};

export const useOrderCreationMethods = () => {
  const { data: stores } = useStores();

  const RCMP = findStoreIdByRCMP(stores, "Remote Customer Meeting Point");

  const { data: storePref } = useStorePreference(RCMP);
  const orderCreationMethods = addAdditionalOrderMethods(
    storePref?.orderCreationMethod || []
  );
  return orderCreationMethods;
};
